var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "cost-unit-add-payment-modal",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            size: "xl",
            title: "Zahlung hinzufügen",
            visible: _vm.isModalOpen,
          },
          on: {
            hide: function ($event) {
              return _vm.hideReset()
            },
            show: _vm.loadForm,
          },
        },
        [
          _c(
            "div",
            { staticClass: "record-cost-unit-edit-modal" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  ref: "costUnitInfoCard",
                  attrs: {
                    cols: 12,
                    "form-context": _vm.formContext,
                    icon: "inticon-users",
                    title: "Zahlung",
                  },
                  on: {
                    "cancel-form": _vm.reset,
                    save: _vm.savePaymentFormData,
                  },
                },
                [
                  _c("h2", [_vm._v("Zahlung hinzufügen")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-5",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Art der Zahlung",
                          property: "paymentType",
                          required: true,
                          type: "autocomplete",
                        },
                        on: { change: _vm.handlePaymentTypeChange },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-2",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Bezahlt am",
                          property: "datePaid",
                          required: true,
                          type: "datepicker",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-2",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Betrag",
                          property: "amount",
                          required: true,
                          type: "currency",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          autocomplete: "on",
                          "form-context": _vm.formContext,
                          label: "Bemerkung",
                          property: "description",
                          type: "text",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }